module.exports = __webpack_public_path__ + "img/50321a6.jpg";